import { generatePath } from "react-router"
import { HIGHLIGHT, AD, WEISCHER, TITLE, TEXT, IMAGE, ADVERTISEMENT, METRO, NEWSLETTER_IMAGE, NEWSLETTER_TEXT, BOTTOMITEMS, CUSTOMITEMS } from '../../../constants/itemTypes'
import AddAdContainer from './AddAdContainer'
import AddHighlightContainer from './AddHighlightContainer'
import AddImageContainer from './AddImageContainer'
import AddTextContainer from './AddTextContainer'
import AddTitleContainer from './AddTitleContainer'
import AddWeischerAdContainer from './AddWeischerAdContainer'
import AddAdvertisementsContainer from './AddAdvertisementsContainer'
import AddMetroContainer from './AddMetroContainer'
import AddNewsletterElementContainer from './AddNewsletterElementContainer'
import { FLYER } from '../../../constants/printType'
import AddFlyerContainer from './AddFlyerContainer'
import AddCustomItemsContainer from './AddCustomItemsContainer'

const PageAddItemContainer = ({match, goBackPath}) => {
    const { itemType, weischerType, printType, campaignId, cinemaId } = match.params
    const closePagePath = generatePath(goBackPath, match.params)
    const suffixEdit = match.path.endsWith('/addItem/form') ? '/edit-item' : ''

    if(printType === FLYER && !itemType) {
        return <AddFlyerContainer
            closePagePath={closePagePath}
        />
    } else if(HIGHLIGHT === itemType) {
        return <AddHighlightContainer
            closePagePath={closePagePath}
            suffixEdit={suffixEdit}
        />
    } else if (AD === itemType) {
        return <AddAdContainer
            closePagePath={closePagePath}
            suffixEdit={suffixEdit}
        />
    } else if(ADVERTISEMENT === itemType)  {
        return <AddAdvertisementsContainer  
            params={match.params}
            closePagePath={closePagePath}
        />
    } else if (WEISCHER === itemType) {
        return <AddWeischerAdContainer
            closePagePath={closePagePath}
            weischerType={weischerType}
        />
    } else if (TITLE === itemType) {
        return <AddTitleContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if (TEXT === itemType && printType) {
        return <AddTextContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if (IMAGE === itemType && printType) {
        return <AddImageContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if(CUSTOMITEMS === itemType) {
        return <AddCustomItemsContainer
            closePagePath={closePagePath}
            itemType={itemType}
            cinemaId={cinemaId}
        />
    } else if(METRO === itemType) {
        return <AddMetroContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else if((NEWSLETTER_TEXT === itemType && campaignId) || (NEWSLETTER_IMAGE === itemType && campaignId)) {
        return <AddNewsletterElementContainer
            closePagePath={closePagePath}
            itemType={itemType}
        />
    } else {
        return <div>Error</div>
    }
}

export default PageAddItemContainer